"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16MenuEditFill = function Svg16MenuEditFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8a1 1 0 0 1 1 1v6.8c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085C7.25 18 7.623 18 8.2 18H15a1 1 0 1 1 0 2H8.161c-.527 0-.981 0-1.356-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167A17.9 17.9 0 0 1 4 15.838V9a1 1 0 0 1 1-1z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.228 4c.111 0 .294 0 .463.013.207.017.562.065.944.26a2.5 2.5 0 0 1 1.093 1.092c.194.382.242.737.259.944.013.169.013.352.013.463v6.456c0 .111 0 .294-.013.463a2.506 2.506 0 0 1-.26.944 2.5 2.5 0 0 1-1.092 1.092 2.503 2.503 0 0 1-.944.26c-.169.013-.352.013-.463.013h-6.456c-.111 0-.294 0-.463-.014a2.504 2.504 0 0 1-.944-.259 2.5 2.5 0 0 1-1.092-1.092 2.505 2.505 0 0 1-.26-.944A5.8 5.8 0 0 1 8 13.228V6.772c0-.111 0-.294.014-.463.016-.207.064-.562.259-.944a2.5 2.5 0 0 1 1.092-1.093c.382-.194.737-.242.944-.259C10.478 4 10.66 4 10.772 4h6.456zM11 8a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16MenuEditFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16MenuEditFill;
exports.default = _default;